import { useEffect, useState } from 'react';
import { formatEvent } from '../helpers/events';

const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'];
const SCOPES = 'https://www.googleapis.com/auth/calendar.readonly';

let isApiLoaded;
let isLoadingApi;

// Load the SDK asynchronously
const loadGoogleSDK = () => {
  isLoadingApi = true;
  (function (d, s, id) {
    let js;
    const fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      window.onGoogleLoad();
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = 'https://apis.google.com/js/api.js?onload=onGoogleLoad';
    js.onload = 'onGoogleLoad';
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'google-jssdk'));
};

// Init the Google API client
const initClient = () => window.gapi.client.init({
  apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  discoveryDocs: DISCOVERY_DOCS,
  scope: SCOPES,
});

// Load events from Google Calendar between 2 dates
const loadEventsFromApi = (from, until) => window.gapi.client.calendar.events.list({
  calendarId: process.env.REACT_APP_GOOGLE_CALENDAR_ID,
  timeMin: from.toISOString(),
  timeMax: until.toISOString(),
  showDeleted: false,
  singleEvents: true,
  maxResults: 100,
  orderBy: 'startTime',
})
  .then((response) => response.result.items.map(formatEvent));

const useGoogleApi = (firstDay, lastDay) => {
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getEvents = (from, until) => {
    if (isApiLoaded) {
      setIsLoading(true);
      loadEventsFromApi(from, until).then((events) => {
        setIsLoading(false);
        setEvents(events);
      });
    }
  };

  useEffect(() => {
    // Load the Google API Client
    window.onGoogleLoad = () => {
      window.gapi.load('client', () => {
        initClient().then(() => {
          isApiLoaded = true;
          loadEventsFromApi(firstDay, lastDay).then((res) => {
            setIsLoading(false);
            setEvents(res);
          });
        });
      });
    };
    if (!isLoadingApi) {
      loadGoogleSDK();
    }
  }, [firstDay, lastDay]);

  return { isLoading, events, getEvents };
};

export default useGoogleApi;
